import type { ThunkQuoteResponse } from "./types";

export const isThunkQuoteResponse = (payload: any): payload is ThunkQuoteResponse => (payload && typeof payload.quoteIds !== 'undefined' && typeof payload.counts !== 'undefined');